<template>
  <div>
    <div
      v-for="(question, key) in value"
      :key="question.id"
      :class="{
        'pt-4': key !== 0 || !hasDivider,
        'border-bottom pb-5': hasDivider,
      }"
    >
      <div class="font-weight-bold d-flex align-items-center mb-2">
        {{ getTitle(question, key) }}
      </div>
      <div>
        <div v-if="isNumber(question)" class="w-25">
          <number v-model="question.value" :is-read-only="isReadOnly" />
        </div>
        <div v-else-if="isTextArea(question)">
          <custom-text-area
            v-model="question.value"
            :disabled="isReadOnly"
            :maxlength="3000"
            placeholder="Escribe tu respuesta"
          />
        </div>
        <div v-else-if="isCheckVertical(question)">
          <checks
            v-model="question.value"
            :is-read-only="isReadOnly"
            :options="question.answers"
          />
        </div>
        <div v-else-if="isCheckHorizontal(question)">
          <checks
            v-model="question.value"
            horizontal
            :is-read-only="isReadOnly"
            :options="question.answers"
          />
        </div>
        <div v-else-if="isRadioVertical(question)">
          <radios
            v-model="question.value"
            :is-read-only="isReadOnly"
            :options="question.answers"
          />
        </div>
        <div v-else-if="isRadioHorizontal(question)">
          <radios
            v-model="question.value"
            horizontal
            :is-read-only="isReadOnly"
            :options="question.answers"
          />
        </div>
        <div v-else-if="isRadioWithLinkedAnswerQuestions(question)">
          <radios
            v-model="question.value"
            :is-read-only="isReadOnly"
            :options="question.answers"
          />
        </div>
        <div v-else>
          -
        </div>
        <slot
          v-if="showAnswerQuestions(question)"
          :answered="question.value"
          name="selected-answer-questions"
          :parent="{ question, index: key }"
          :questions="getAnswerQuestions(question)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import Number from './questionTypes/Number.vue';
import Checks from './questionTypes/Checks.vue';
import Radios from './questionTypes/Radios.vue';
import TYPES from '@/utils/constants/rubricAnswerQuestionTypes';

export default {
  name: 'RubricPreviewQuestions',
  components: {
    CustomTextArea,
    Number,
    Checks,
    Radios,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    hasDivider: {
      type: Boolean,
      default: () => false,
    },
    ordered: {
      type: Boolean,
      default: () => false,
    },
    parent: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isNumber() {
      return ({ typeId }) => typeId === TYPES.NUMERICALTEXT;
    },
    isTextArea() {
      return ({ typeId }) => typeId === TYPES.OPENTEXT;
    },
    isCheckVertical() {
      return ({ typeId }) => typeId === TYPES.MULTIPLEVERTICAL;
    },
    isCheckHorizontal() {
      return ({ typeId }) => typeId === TYPES.MULTIPLEHORIZONTAL;
    },
    isRadioVertical() {
      return ({ typeId }) => typeId === TYPES.SIMPLEVERTICAL;
    },
    isRadioHorizontal() {
      return ({ typeId }) => typeId === TYPES.SIMPLEHORIZONTAL;
    },
    isRadioWithLinkedAnswerQuestions() {
      return ({ typeId }) => typeId === TYPES.SIMPLEWITHCHILD;
    },
    showAnswerQuestions() {
      return ({ value, childQuestions }) => value?.id && childQuestions?.length;
    },
    getAnswerQuestions() {
      return ({ childQuestions, value }) =>
        childQuestions.filter((x) => x.linkedAnswer?.id == value.id);
    },
    getTitle() {
      return ({ name }, key) => {
        if (!this.ordered) return name;

        return this.parent?.index >= 0
          ? `${key + 1}.${this.parent.index + 1} ${name}`
          : `${key + 1}. ${name}`;
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/brand_variables.scss';
</style>
